module.exports = __webpack_public_path__ + "img/altitude-resort-6.0a5523cd.jpg";